const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/Gifting.css");

module.exports = createReactClass({
	displayName: "GiftInlineModal",
	propTypes: {
		recipientEmail: PT.string,
		senderName: PT.string,
		studentName: PT.string,
		deliveryDate: PT.oneOfType([PT.instanceOf(Date), PT.string]),
		deliveryDateUTC: PT.oneOfType([PT.instanceOf(Date), PT.string]),
		personalizedMessage: PT.string,
		onClose: PT.func,
		onSave: PT.func,
	},

	getInitialState: function() {
		return {
			formData: {
				recipientEmail: this.props.recipientEmail || "",
				senderName: this.props.senderName || "",
				studentName: this.props.studentName || "",
				deliveryDate: this.props.deliveryDate || "",
				deliveryDateUTC: this.props.deliveryDateUTC || "",
				personalizedMessage: this.props.personalizedMessage || "",
			},
			errors: {},
		};
	},

	handleChange: function(event) {
		const {name, value} = event.target;
		this.setState(prevState => ({
			formData: {
				...prevState.formData,
				[name]: value,
			},
			errors: {...prevState.errors, [name]: ""},
		}));
	},

	validateDeliveryDate: function() {
		const {deliveryDate} = this.state.formData;

		if (!deliveryDate || deliveryDate === "") {
			// no deliveryDate selected => deliver immediately
			// so this is valid
			return true;
		}

		// The below is copied from GiftingUtil.js
		const currentDatetime = new Date();
		let currentLocalDate = currentDatetime.toLocaleDateString();
		currentLocalDate = new Date(currentLocalDate);

		const inputDateString = deliveryDate + " 00:00:00";
		const inputTimeToSend = new Date(inputDateString);

		return inputTimeToSend >= currentLocalDate;
	},

	getUTCTimestamp: function(deliveryDate) {
		const localDeliveryDate = deliveryDate + " 00:00:00";
		return new Date(localDeliveryDate);
	},

	validateForm: function() {
		const {recipientEmail, senderName} = this.state.formData;
		const errors = {};

		if (!senderName.trim()) {
			errors.senderName = "*Please enter your name.";
		}

		const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!recipientEmail.trim() || !emailPattern.test(recipientEmail)) {
			errors.recipientEmail = "*Please enter a valid email address.";
		}

		if (!this.validateDeliveryDate()) {
			errors.deliveryDate = "*Delivery date cannot be in the past.";
		}
		return errors;
	},

	handleModalSave: function() {
		const errors = this.validateForm();
		if (Object.keys(errors).length > 0) {
			this.setState({errors});
			return; // Prevent saving if there are validation errors
		}
		this.props.onSave(this.state.formData);
	},

	render: function() {
		const {formData, errors} = this.state;
		const fieldNameMap = {
			recipientEmail: "Recipient Email (Parent or Guardian)*",
			senderName: "From*",
			studentName: "To (Optional)",
			deliveryDate: "Delivery Date (Optional)",
			personalizedMessage: "Personalized Message (Optional)",
		};
		const placeholderTextMap = {
			recipientEmail: "Email",
			senderName: "Your Name",
			studentName: "Student Name",
			deliveryDate: null,
			personalizedMessage:
				"Share a personalized message with your student (250 characters)",
		};

		const specialFieldInfoMap = {
			deliveryDate: (
				<input
					className={
						errors["deliveryDate"] ? styles.errorInputField : styles.inputField
					}
					type="date"
					name="deliveryDate"
					value={formData["deliveryDate"]}
					onChange={this.handleChange}
				/>
			),
			personalizedMessage: (
				<textarea
					className={styles.largeInputField}
					rows="2"
					name="personalizedMessage"
					value={formData["personalizedMessage"]}
					onChange={this.handleChange}
					placeholder={placeholderTextMap["personalizedMessage"] || ""}
					maxLength={250}
				/>
			),
		};

		return (
			<div className={styles.modalContainer}>
				<div className={styles.modalHeader}>Update Recipient Details</div>
				{Object.keys(fieldNameMap).map(field => (
					<div className={styles.fieldContainer} key={field}>
						<label className={styles.fieldName}>
							{fieldNameMap[field] || ""}
						</label>
						{field === "personalizedMessage" || field === "deliveryDate" ? (
							specialFieldInfoMap[field]
						) : (
							<input
								className={
									errors[field] ? styles.errorInputField : styles.inputField
								}
								type="text"
								name={field}
								value={formData[field]}
								onChange={this.handleChange}
								placeholder={placeholderTextMap[field] || ""}
							/>
						)}
						{errors[field] ? (
							<div className={styles.errorMessageVisible}>{errors[field]}</div>
						) : (
							<div className={styles.errorMessageHidden} />
						)}
						{field === "recipientEmail" ? (
							<div className={styles.disclaimerText}>
								Email entered must be of someone 18+. Recipient email must be
								US-based.
								<div className={styles.horizontalLine} />
							</div>
						) : (
							<></>
						)}
					</div>
				))}

				<div className={styles.buttonContainer}>
					<button className={styles.cancelBtn} onClick={this.props.onClose}>
						Cancel
					</button>
					<button
						className={styles.saveBtn}
						onClick={() => this.handleModalSave()}
					>
						Save
					</button>
				</div>
			</div>
		);
	},
});
